export enum PackageSelectionType {
    Limited = 'Limited',
    Full = 'Full',
    Hybrid = 'Hybrid',
}
